import { FC } from "react";

import CopyrightAlt from "components/Copyright/CopyrightAlt";

import { Container } from "./styles";

const MainFooter: FC = () => {
  return (
    <Container>
      <CopyrightAlt />
    </Container>
  );
};

export default MainFooter;
